import React, { FC } from 'react';
import { Category } from '@components/Atoms/Category';
import styled from 'styled-components';

interface Props {
  blog_title: string;
  published_at: string;
  categories: Array<{ id: number; category_name: string }>;
  headingLevel?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

const StyledBlogHeader = styled.div`
  .blog-header {
    &__title {
      color: var(--colors-primary-bright);
    }

    &__publish-date {
      color: var(--color-black);
      font-weight: 600;
    }

    &__categories {
      display: flex;
      flex-wrap: wrap;
      column-gap: 1rem;
      margin-top: 0.5rem;
      justify-content: center;
    }

    .category {
      margin-top: 0.5rem;
    }
  }
`;

export const BlogHeader: FC<Props> = ({
  blog_title,
  published_at,
  categories,
  headingLevel = 'h1',
}) => {
  const publishDate = new Date(published_at).toLocaleDateString('en-GB');
  const HeadingComponent = headingLevel;
  return (
    <StyledBlogHeader>
      <div className="blog-header">
        <HeadingComponent className="blog-header__title">{blog_title}</HeadingComponent>
        <p className="blog-header__publish-date">{publishDate}</p>
        {categories && (
          <div className="blog-header__categories">
            {categories.map((category: any) => (
              <Category key={category.id} text={category.category_name} />
            ))}
          </div>
        )}
      </div>
    </StyledBlogHeader>
  );
};
